import { memo } from 'react'
import { Box } from '@mui/material'

// Per-role styling lookup — flat object beats the previous 9-ternary inline sx
const ROLE_SX = {
    user: {
        alignSelf: 'flex-end',
        bgcolor: '#003366',
        color: 'white',
        fontStyle: 'normal',
        fontSize: 13,
        px: 1.5,
        py: 1,
        maxWidth: '85%',
    },
    assistant: {
        alignSelf: 'flex-start',
        bgcolor: '#f0f2f5',
        color: '#2c3e50',
        fontStyle: 'normal',
        fontSize: 13,
        px: 1.5,
        py: 1,
        maxWidth: '85%',
    },
    system: {
        alignSelf: 'center',
        bgcolor: 'transparent',
        color: '#999',
        fontStyle: 'italic',
        fontSize: 12,
        px: 1,
        py: 0.5,
        maxWidth: '100%',
    },
}

const COMMON_SX = {
    borderRadius: 1,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5,
}

function ChatMessage({ role, text }) {
    return <Box sx={{ ...COMMON_SX, ...(ROLE_SX[role] || ROLE_SX.assistant) }}>{text}</Box>
}

export default memo(ChatMessage)
